module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/noDataFaceIcon.5dd0f99f.svg";